import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  error?: string;
}
export function InputField({
  icon,
  error,
  className = '',
  type,
  id,
  ...props
}: InputFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? showPassword ? 'text' : 'password' : type;
  const inputId = id || props.name;
  return <div className="w-full mb-4" data-id="element-260" data-mp="2jy6uhepi3ey2">
      <div className="relative" data-id="element-261" data-mp="2jv131steg0z6">
        {icon && <div className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-262" data-mp="2ex9bizwo2gvi">
            {icon}
          </div>}
        <input id={inputId} type={inputType} className={`w-full h-[52px] rounded-input border border-border bg-white text-text-primary placeholder:text-text-secondary transition-all duration-300 outline-none focus:border-primary focus:shadow-focus ${icon ? 'pl-11' : 'pl-4'} ${isPassword ? 'pr-11' : 'pr-4'} ${error ? 'border-danger' : ''} ${className}`} {...props} data-id="element-263" data-mp="29yposxa91123" />
        {isPassword && <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-text-secondary hover:text-text-primary transition-colors" aria-label={showPassword ? 'Hide password' : 'Show password'} data-id="element-264" data-mp="3i2qs7gzo0cv5">
            {showPassword ? <EyeOff size={20} data-id="element-265" data-mp="3d4fgf0pt7saa" /> : <Eye size={20} data-id="element-266" data-mp="3d4oy810pat4w" />}
          </button>}
      </div>
      {error && <p className="mt-1.5 text-sm text-danger animate-fadeInUp" data-id="element-267" data-mp="2zdk7jofb9b6p">{error}</p>}
    </div>;
}